export const getDate = () => {
    const utcTime = Date.now();
    const date = new Date(utcTime).toLocaleString("en-IN", { year: 'numeric', month: '2-digit', day: '2-digit' });

    return date;
}